import React, { Fragment, useState } from 'react';
import { Btn, H4 } from '../../AbstractElements';
import { supportColumns, supportData } from '../../Data/SupportTicket';
import TicketTable from './TicketTable';

const TicketTableWrapper = () => {
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleDelet, setToggleDelet] = useState(false);
  const [data, setData] = useState(supportData);

  const handleDelete = () => {
    if (window.confirm(`Are you sure you want to delete:\r ${selectedRows.map((r) => r.title)}?`)) {
      setToggleDelet(!toggleDelet);
      setData(data.filter((item) => (selectedRows.filter((elem) => elem.id === item.id).length > 0 ? false : true)));
      setSelectedRows('');
    }
  };
  return (
    <Fragment>
      <div className='table-responsive support-table'>
        {selectedRows.length !== 0 && (
          <div className={`d-flex align-items-center justify-content-between bg-light-info p-2`}>
            <H4 className='text-muted m-0'>Delet Selected Data..!</H4>
            <Btn color='danger' onClick={() => handleDelete()}>
              Delete
            </Btn>
          </div>
        )}
        <TicketTable data={data} supportColumns={supportColumns} toggleDelet={toggleDelet} setSelectedRows={setSelectedRows} />
      </div>
    </Fragment>
  );
};
export default TicketTableWrapper;
